import {FC} from 'react'
import clsx from 'clsx'

type Props = {
  /** The site's whiter gradient and its three dotted data flows; for the sign-in pages. */
  site?: boolean
}

// The site's fixed backdrop: a faint ledger grid near the top and two slow brand glows (plus, on
// the sign-in pages, the dotted flows that carry invoices to the tax system). It stays behind
// everything, takes no clicks, stands still under «reduce motion» and is not printed.
const AppBackdrop: FC<Props> = ({site = false}) => (
  <div className={clsx('asa-backdrop', site && 'asa-backdrop--site')} aria-hidden='true'>
    <span className='asa-backdrop__grid' />
    <span className='asa-backdrop__glow asa-backdrop__glow--a' />
    <span className='asa-backdrop__glow asa-backdrop__glow--b' />
    {site && (
      <svg
        className='asa-backdrop__flows'
        viewBox='0 0 1440 900'
        preserveAspectRatio='xMidYMid slice'
        focusable='false'
      >
        <defs>
          <linearGradient id='asa-backdrop-flow-stroke' x1='0' x2='1' y1='0' y2='0'>
            <stop offset='0' stopColor='#00a5e3' stopOpacity='0' />
            <stop offset='0.35' stopColor='#00a5e3' stopOpacity='0.55' />
            <stop offset='0.75' stopColor='#40ba8d' stopOpacity='0.55' />
            <stop offset='1' stopColor='#40ba8d' stopOpacity='0' />
          </linearGradient>
        </defs>
        <path className='asa-backdrop__flow' d='M-60 700 C 300 610 540 770 840 575 S 1250 380 1520 430' />
        <path
          className='asa-backdrop__flow asa-backdrop__flow--2'
          d='M-60 240 C 250 330 560 140 880 250 S 1250 520 1520 470'
        />
        <path
          className='asa-backdrop__flow asa-backdrop__flow--3'
          d='M-60 470 C 380 425 640 520 960 415 S 1310 210 1520 180'
        />
      </svg>
    )}
  </div>
)

export {AppBackdrop}
